import { buildElementObject } from "../shared/buildElementObject";
import { buildNavigationType } from "../shared/buildNavigationType";
import { buildPageObject } from "../shared/buildPageObject";
import { EventAction, EventName } from "../types";

import type { ElementSelectEvent, ElementSelectInput } from "./types";

type EventBuilder = (input: ElementSelectInput) => ElementSelectEvent;

const elementSelectEventBuilder: EventBuilder = (input) => {
  const { elementName, customProperties } = input;

  const timestamp = new Date().toISOString();

  const elementObject = buildElementObject(elementName);
  const pageObject = buildPageObject();
  const navigationType = buildNavigationType();

  return {
    name: EventName.ElementSelect,
    action: EventAction.Select,
    target: elementObject,
    origin: pageObject,
    navigationType,
    timestamp,
    customProperties,
  };
};

export { elementSelectEventBuilder };
